export const END_USER = 'enduser';
export const AGENT = 'agent';
export const SUPERVISOR = 'supervisor';
export const SUPER_ADMIN = 'superadmin';
export const ADMIN = 'admin';